export const getOptionLabel = (options: { value: string | number, label: string }[], value?: string | number | null ) => {
  if (!value) return null;
  const option = options.find(({ value: optionValue }) => value === optionValue);
  return option?.label;
};
